import instance from '../instance';
import getLiveElement from './get-live-element';

const getInlineElementStyle = (elementId, propertyName) => {
  const element = getLiveElement(elementId);
  return instance.driver.getInlineElementStyle(element, propertyName);
};
export default getInlineElementStyle;
